module.exports = __webpack_public_path__ + "media/images/home/tada-eda4b5545ef06f397c9c0019ebe6c6d7.png";